export default __webpack_public_path__ + "static/media/H1003.6.0f55429a.mp3";